import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { HiOutlineIdentification } from 'react-icons/hi';
import { FaSuitcaseRolling } from 'react-icons/fa';

//Import your existing components

import Booking from '../common/RoomnoCheckout';
import DueForCheckIn from '../check-out/Checkoutdetails';

const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

const CheckoutOptions = () => {
  const navigate = useNavigate();
  const [activeOption, setActiveOption] = useState('due-for-checkin');
  const [propertyData, setPropertyData] = useState({
    phone: '', // Default value
  });

  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const response = await fetch(`${BQ_BASE_URL}/bq/api/properties/1`);
        const data = await response.json();
        setPropertyData(data);
      } catch (error) {
        console.error('Error fetching property data:', error);
      }
    };

    fetchPropertyData();
  }, []);

  const options = [
    {
      id: 'due-for-checkin',
      title: 'Due for Check-Out',
      description: 'View all reservations that are due for check-out',
      icon: <FaSuitcaseRolling size={32} className="text-white" />,
      component: <DueForCheckIn />,
      fastest: false,
      new: false,
    },
    {
      id: 'reservation-id',
      title: 'Room Checkout',
      description: 'Enter your Room Number and Last Name to proceed',
      icon: <HiOutlineIdentification size={32} className="text-white" />,
      component: <Booking />,
      fastest: false,
      new: false,
    },
  ];

  const handleOptionClick = (option) => {
    setActiveOption(option.id);
  };

  const getActiveComponent = () => {
    const option = options.find((opt) => opt.id === activeOption);
    return option ? option.component : <Booking />;
  };

  return (
    <div className="bg-white min-h-screen overflow-hidden">
      {/* Back Button - Fixed position */}
      <div className="absolute top-24 left-8 z-50">
        <Link
          to="/check-in/options"
          className="text-black hover:text-gray-700 transition font-semibold text-2xl"
        >
          <IoMdArrowRoundBack size={32} />
        </Link>
      </div>

      {/* Main Content */}
      <div className=" px-16  pt-20 pb-10">
        <div className="text-center mb-4">
          <h1 className="text-3xl font-bold text-black font-poppins mb-1">Ready to check out?</h1>
          <p className="text-lg font-poppins font-semibold text-gray-700">
            Choose from your checked-in rooms below to proceed with checkout.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          {/* Options Sidebar */}
          <div className="w-full lg:w-2/5 xl:w-2/6">
            <div className="bg-gray-50 rounded-lg shadow-md p-4">
              {options.map((option) => (
                <div
                  key={option.id}
                  className={`mb-4 last:mb-0 p-4 font-poppins rounded-lg cursor-pointer transition-all ${
                    activeOption === option.id
                      ? 'bg-black text-white'
                      : 'bg-white hover:bg-gray-100'
                  }`}
                  onClick={() => handleOptionClick(option)}
                >
                  <div className="flex items-center">
                    <div
                      className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 ${
                        activeOption === option.id ? 'bg-white' : 'bg-black'
                      }`}
                    >
                      {React.cloneElement(option.icon, {
                        className: activeOption === option.id ? 'text-black' : 'text-white',
                      })}
                    </div>
                    <div className="flex-grow">
                      <div className="flex items-center justify-between">
                        <h3 className="font-bold text-lg">{option.title}</h3>
                        {option.fastest && (
                          <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded ml-2 whitespace-nowrap">
                            Fastest
                          </span>
                        )}
                        {option.new && (
                          <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-4 py-0.5 rounded ml-2 whitespace-nowrap">
                            New
                          </span>
                        )}
                      </div>
                      <p className="text-sm">{option.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Active Option Content */}
          <div className="w-full lg:w-5/6">
            <div className="flex flex-col gap-4">
              {/* Top Box */}
              <div className="bg-white rounded-lg shadow-md border border-gray-200 min-h-[500px] p-6 flex items-center justify-center">
                <div className="w-full">{getActiveComponent()}</div>
              </div>

              <div className="text-start mt-2 ml-10">
                <span className="text-sm font-semibold uppercase text-black">
                  In case you need any assistance,&nbsp;
                  <span className="block sm:inline">please contact our Front Desk or call:</span>
                  &nbsp;
                  <a href={`tel:${propertyData.phone}`} className="underline hover:text-gray-700">
                    {propertyData.phone}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutOptions;
